import { googleMapAPIKey } from '../settings';
import axiosInstance from './axiosInstance';

export async function getLocationDetails(lat, long) {
  try {
    const res = await axiosInstance({
      url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${googleMapAPIKey}`,
      method: 'GET',
      withCredentials: false,
    });
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (e) {
    throw e;
  }
}

export async function getIPLocation() {
  try {
    const res = await axiosInstance({
      url: `https://www.googleapis.com/geolocation/v1/geolocate?key=${googleMapAPIKey}`,
      method: 'POST',
      withCredentials: false,
    });
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (e) {
    console.error('Error fetching location:', e); // Log the error for debugging
    return null;
  }
}

export async function getLocationByAddress(address) {
  try {
    const res = await axiosInstance({
      url: `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${googleMapAPIKey}`,
      method: 'GET',
      withCredentials: false,
    });
    if (res && res.data && res.status === 200) {
      return res;
    } else {
      return null;
    }
  } catch (e) {
    throw e;
  }
}
